import { CLAIM_TABS } from '../constants';
import { searchWithTab } from './appeals-v2-helpers';

export const knownClaimTab = value =>
  CLAIM_TABS.some(tab => tab.id === value) ? value : null;

export const labelForTab = id => CLAIM_TABS.find(tab => tab.id === id).label;

export const searchWithoutTab = search => {
  const params = new URLSearchParams(search);
  params.delete('tab');
  const str = params.toString();
  return str ? `?${str}` : '';
};

// Router `to` object for navigate()/<Navigate> at sites directly under
// your-claims/:id.
export const claimTabTo = (tab, { search = '', hash = '' } = {}) => ({
  pathname: '..',
  search: searchWithTab(search, tab),
  hash,
});

// App-relative absolute string for navigate() at sites that render at more
// than one route depth (the router prepends the basename).
export const claimTabPath = (claimId, tab, { search = '', hash = '' } = {}) =>
  `/your-claims/${claimId}${searchWithTab(search, tab)}${hash}`;

// BasicLink accepts only path/search strings and no-ops on a falsy path, so
// the hash rides at the end of search.
export const claimTabLinkProps = (
  tab,
  { claimId, search = '', hash = '' } = {},
) => ({
  path: `/your-claims/${claimId}`,
  search: `${searchWithTab(search, tab)}${hash}`,
});

// Fully-prefixed string for raw va-link hrefs only; never pass to navigate().
export const claimTabHref = (claimId, tab, { search = '', hash = '' } = {}) =>
  `/track-claims/your-claims/${claimId}${searchWithTab(search, tab)}${hash}`;

export const claimTabCrumbHref = (tab, { search = '' } = {}) =>
  `..${searchWithTab(search, tab)}`;

export const isOnFilesView = (location, claimId) => {
  const tab = new URLSearchParams(location.search).get('tab');
  if (claimId) {
    const base = `/track-claims/your-claims/${claimId}`;
    return (
      location.pathname === `${base}/files` ||
      (tab === 'files' && location.pathname === base)
    );
  }
  return location.pathname.endsWith('/files') || tab === 'files';
};
